// extracted by mini-css-extract-plugin
export var list = "tech-list-module--list--9OTZM";
export var item = "tech-list-module--item--hn1rK";
export var iconWrapper = "tech-list-module--icon-wrapper--mU66B";
export var icon = "tech-list-module--icon--R-R2h";
export var label = "tech-list-module--label--2AiWz";